import {Component, OnInit} from '@angular/core';
import {HelperService} from "../helper.service";
import {NavController} from "@ionic/angular";
import {CorpusService} from "../corpus.service";
import {AnnisResponse} from "../../../openapi";
import {HttpErrorResponse} from "@angular/common/http";
import {CorpusMC} from "../models/corpusMC";
import {TextRange} from "../models/textRange";
import {take} from "rxjs/operators";
import {ApplicationState} from "../models/applicationState";
import {TextData} from "../models/textData";
import {Author} from "../models/author";
import configMC from "../../configMC";

@Component({
    selector: 'app-upload-text',
    templateUrl: './upload-text.component.html',
    styleUrls: ['./upload-text.component.css']
})
export class UploadTextComponent implements OnInit {
    currentText: string = '';

    constructor(
        public corpusService: CorpusService,
        public helperService: HelperService,
        public navCtrl: NavController,
    ) {
    }

    ngOnInit(): void {
    }

    showTextComplexity(): Promise<void> {
        return new Promise((resolve) => {
            this.corpusService.currentText = this.currentText;
            const tr: TextRange = new TextRange({start: ['', '', ''], end: ['', '', '']});
            this.corpusService.currentTextRange.next(tr);
            this.corpusService.getAnnotationsForCustomText().then((ar: AnnisResponse) => {
                this.corpusService.processAnnisResponse(ar);
                this.corpusService.currentUrn = ar.uri;
                const corpus: CorpusMC = {source_urn: ar.uri, title: this.corpusService.myTextString, cid: -999};
                this.corpusService.currentCorpus.next(corpus);
                this.helperService.applicationState.pipe(take(1)).subscribe((state: ApplicationState) => {
                    state.mostRecentSetup = new TextData({
                        currentTextRange: tr,
                        currentUrn: corpus.source_urn,
                        currentCorpus: corpus,
                        currentAuthor: new Author({name: ''}),
                        annisResponse: ar
                    });
                    this.helperService.saveApplicationState(state).then();
                });
                this.corpusService.isTextRangeCorrect = true;
                this.helperService.goToPage(this.navCtrl, configMC.pageUrlShowText).then();
                return resolve();
            }, (error: HttpErrorResponse) => {
                return resolve();
            });
        });
    }
}
